import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
const blocks = [{
  n: '01',
  title: 'Diagnóstico',
  text: 'Leé el cabello antes de tocar nada. Cero errores evitables.'
}, {
  n: '02',
  title: 'Aplicación',
  text: 'Técnica por zonas, tiempos y control del proceso. Sin quemas. Sin herradura.'
}, {
  n: '03',
  title: 'Corrección',
  text: 'Matización, corrección de amarillos, cómo salvar un blanco que se va mal.'
}, {
  n: '04',
  title: 'Presentación',
  text: 'Cómo mostrarlo, terminarlo y entregarlo para que el cliente perciba más valor.'
}, {
  n: '05',
  title: 'Precio y cobro',
  text: 'Cómo fijarlo, comunicarlo y defenderlo. Sin incomodidad. Sin negociación.'
}];
const includes = ['Protocolo paso a paso', 'Scripts de consulta listos', 'Sistema de mantenimiento y recurrencia', '100% adaptado a Argentina', 'PDF listo para usar hoy'];
export function Method() {
  return <section id="metodo" aria-label="El método" className="border-b border-ink-700 bg-ink-950 py-16 sm:py-20" data-id="element-120" data-mp="pemyps9kclyi">
      <div className="mx-auto w-full max-w-page px-5 sm:px-8" data-id="element-121" data-mp="fpd527z2mv8a">
        <SectionHeading label="El método" title="🏆 Pack Blanco Perfecto — 1 tomo · 5 bonos" subtitle="150 páginas. Diagnóstico → Técnica → Corrección → Presentación → Cobro." data-id="element-122" data-mp="fns5u51tao43" />

        <div className="mt-12 grid gap-10 lg:grid-cols-[1.15fr_0.85fr] lg:gap-14" data-id="element-123" data-mp="6mkde3lz8hhx">
          <ol className="grid gap-px bg-ink-700" data-id="element-124" data-mp="1rwv4mhkgjbs">
            {blocks.map((block, i) => <motion.li key={block.n} initial={{
            opacity: 0,
            y: 14
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.4,
            delay: i * 0.06
          }} className="flex gap-5 bg-ink-900 p-6 sm:p-7" data-id="element-125" data-mp="3swetfef33k0e" data-mpi={i}>
                <span className="display shrink-0 text-2xl text-ink-700 sm:text-3xl" data-id="element-126" data-mp="3glniauwqdgpb">
                  {block.n}
                </span>
                <div data-id="element-127" data-mp="3ldx4q0ymzymu">
                  <h3 className="display text-lg text-bone sm:text-xl" data-id="element-128" data-mp="3legpdpfo914k">
                    Bloque {Number(block.n)} — {block.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-ash sm:text-base" data-id="element-129" data-mp="3bnm16fiv7rgh">
                    {block.text}
                  </p>
                </div>
              </motion.li>)}
          </ol>

          <div className="lg:sticky lg:top-28 lg:self-start" data-id="element-130" data-mp="85kckup6i23m">
            <div className="border border-ink-700" data-id="element-131" data-mp="3qci5q2lpqmcc">
              <img src="https://cdn.magicpatterns.com/patterns/generated-images/9f79073d-64d8-485a-8d71-e6680d8773c2.jpg" alt="Detalle de un fade con blanco platinado perfectamente matizado" className="aspect-square w-full object-cover" loading="lazy" data-id="element-132" data-mp="3qdt8bz3f9o1v" />
            </div>
            <ul className="mt-6 space-y-3" data-id="element-133" data-mp="2bdup3mdjrtej">
              {includes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-134" data-mp="27dk8lfs4pklf">
                  <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-ice" aria-hidden="true" data-id="element-135" data-mp="27fdgszie4cvj" />
                  <span className="text-sm font-medium text-bone sm:text-base" data-id="element-136" data-mp="2lapkhweixdol">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}